module.exports = __webpack_public_path__ + "img/fenxi.13f6f5ab.png";